"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
const lib_self_1 = __importDefault(require("@opsbase/lib-self"));
const lib_storage_1 = require("@opsbase/lib-storage");
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const react_1 = require("react");
const Auth_1 = __importDefault(require("../Auth"));
function useAuth() {
    const { setSelf, setSelfAndShadow } = (0, useSelfActions_1.default)();
    return (0, react_1.useMemo)(() => ({
        api: {
            init: () => __awaiter(this, void 0, void 0, function* () {
                const selfData = (0, lib_storage_1.getStoredValue)('self');
                const shadowData = (0, lib_storage_1.getStoredValue)('shadow');
                let self;
                let shadow;
                if (selfData)
                    self = lib_self_1.default.fromCompressedData(selfData);
                if (shadowData)
                    shadow = lib_self_1.default.fromCompressedData(shadowData);
                setSelfAndShadow(self, shadow);
                return self;
            }),
            reloadSelf: () => __awaiter(this, void 0, void 0, function* () {
                const self = yield Auth_1.default.api.reloadSelf(true);
                const shadow = yield Auth_1.default.api.reloadSelf();
                setSelfAndShadow(self, shadow);
            }),
            signOut: () => __awaiter(this, void 0, void 0, function* () {
                return Auth_1.default.api.signOut().then(() => __awaiter(this, void 0, void 0, function* () {
                    setSelf(new lib_self_1.default());
                }));
            }),
            otpSignIn: (app, id, passKey) => __awaiter(this, void 0, void 0, function* () {
                return Auth_1.default.api.otpSignIn(app, id, passKey).then((data) => __awaiter(this, void 0, void 0, function* () {
                    setSelf(lib_self_1.default.fromData(data));
                }));
            }),
            shadow: (staffId, organisationId) => __awaiter(this, void 0, void 0, function* () { return Auth_1.default.api.shadow(staffId, organisationId); }),
            shadowTeambaord: (teamboardId, organisationId) => __awaiter(this, void 0, void 0, function* () { return Auth_1.default.api.shadowTeamboard(teamboardId, organisationId); }),
            passKey: (app, identifier) => __awaiter(this, void 0, void 0, function* () { return Auth_1.default.api.passKey(app, identifier); }),
            teamboardSignin: (app, code) => __awaiter(this, void 0, void 0, function* () {
                return Auth_1.default.api.teamboardSignin(app, code).then((data) => __awaiter(this, void 0, void 0, function* () {
                    setSelf(lib_self_1.default.fromData(data));
                }));
            }),
        },
    }), [setSelf, setSelfAndShadow]);
}
exports.useAuth = useAuth;
exports.default = useAuth;
